export const TimelineData = [
  {
    text: "PARTNER BEGINS TO WORK WITH LABORING PERSON",
    x: 71.49999999999994,
    y: -42.25000000000006
  },
  {
    text: "CERVIX OPENS 1-5CM",
    x: 472.5,
    y: -542.5000000000001
  },
  {
    text: "DRINK AND EAT",
    x: 802.8055555555557,
    y: -581.3333333333333
  },
  {
    text: "TAKE A WALK",
    x: 11.841269841269655,
    y: -311.285714285714
  },
  {
    text: "HAPPY, EXCITED, AND/OR ANXIOUS",
    x: -81.4285714285715,
    y: -45.57142857142878
  },
  {
    text: "URINATE OFTEN",
    x: 798.1111111111111,
    y: -514.1111111111115
  },
  {
    text: "LOOSE AND FREQUENT BOWEL MOVEMENTS",
    x: -195.5,
    y: -127.38888888888891
  },
  {
    text: "BAG OF WATERS MAY BREAK",
    x: 1010,
    y: -354
  },
  {
    text: "OPTIMAL TIMING FOR EPIDURAL IF IT IS IN YOUR PLAN",
    x: 938.2142857142853,
    y: -579.7499999999999
  },
  {
    text: "BEST TIME TO USE NARCOTICS IF YOU THEY ARE IN YOUR PLAN",
    x: 937,
    y: -497
  },
  {
    text: "NITROUS CAN BE USED",
    x: 937,
    y: -394
  },
  {
    text: "CERVIX OPENS 6-8CM",
    x: 948.5,
    y: -114.75
  },
  {
    text: "CHANGE POSITIONS OFTEN",
    x: 788,
    y: -454
  },
  {
    text: "BABY PRESSES DOWN HARD, LABORING PERSON FEELS RECTAL PRESSURE",
    x: 1306,
    y: -378.9999999999999
  },
  {
    text: "“I CAN’T DO THIS ANYMORE”",
    x: 1295,
    y: -179
  },
  {
    text: "CONTRACTIONS ARE HARD AND FAST WITH SMALL BREAKS",
    x: 1255,
    y: -640
  },
  {
    text: "LABORING PERSON HAS NEW ENERGY EVEN THOUGH THE WORK IS HARD",
    x: 1477,
    y: -373
  },
  {
    text: "LABORING PERSON FEELS LOTS OF PRESSURE IN BOTTOM",
    x: 1535,
    y: -511
  },
  {
    text: "BABY’S HEAD BEGINS TO CROWN",
    x: 1674,
    y: -644.5
  },
  {
    text: "BURNINGS & STRETCHING IN PERINEUM",
    x: 1585.75,
    y: -280.74999999999994
  },
  {
    text: "CONTRACTIONS LAST 60 – 90 SECONDS",
    x: 261.00000000000006,
    y: -5.999999999999982
  },
  {
    text: "PLACENTA IS EXPELLED",
    x: 1799,
    y: -564
  },
  {
    text: "UTERUS FEELS HARD & STRONG",
    x: 1296,
    y: -110
  },
  {
    text: "BREASTFEEDING IS INITIATED",
    x: 1798,
    y: -497
  },
  {
    text: "MILD CONTRACTIONS AND SHAKY LEGS",
    x: 1797,
    y: -423
  },
  {
    text: "BABY IS IN QUIET ALERT STATE",
    x: 1806,
    y: -645
  },
  {
    text: "VAGINAL REPAIRS",
    x: 1797.25,
    y: -325
  },
  {
    text: "LEAVE FOR HOSPITAL OR BIRTH CENTER",
    x: 1071,
    y: -625
  },
  {
    text: "CALL YOUR PROVIDER",
    x: -58.49999999999986,
    y: -520
  },
  {
    text: "CALL YOUR DOULA",
    x: -25.023809523809547,
    y: 87.92857142857156
  },
  {
    text: "CERVIX IS 10CM",
    x: 1391,
    y: -639
  },
  {
    text: "CONTRACTIONS ARE 20-45 SECONDS LONG",
    x: 278,
    y: 302
  },
  {
    text: "CONTRACTIONS ARE 1 MINUTE LONG",
    x: 629,
    y: 178.99999999999997
  },
  {
    text: "USUALLY THE LONGEST PART OF LABOR",
    x: -186.25000000000003,
    y: -339
  },
  {
    text: "IGNORE AND GO ON WITH REGULAR ACTIVITIES",
    x: 178,
    y: -591
  },
  {
    text: "CONTRACTIONS ARE 3-5 MINUTES APART",
    x: 814,
    y: 81.99999999999997
  },
  {
    text: "CONTRACTIONS ARE 2-3 MINUTES APART",
    x: 1372,
    y: -535
  },
  {
    text: "CONTRACTIONS ARE 5 – 20 MINUTES APART",
    x: 614,
    y: -3.000000000000017
  },
  {
    text: "LABOR IS RHYTHMIC AND PREDICTABLE",
    x: 1072.9999999999998,
    y: -525.9999999999999
  }
];
